import Cookies from 'js-cookie';

import { SessionCookie } from '@/types/cookie';
import { SESSION_COOKIE } from '@/types/cookie';
import { envVarsProvider } from '@/utils/envVars/envVars';

function getBasename(): string {
  const raw = envVarsProvider.get( 'STUDIO_BASE_PATH' ) || '';
  if ( !raw || raw === '/' ) return '';
  const withLeading = raw.startsWith( '/' ) ? raw : `/${ raw }`;
  return withLeading.endsWith( '/' ) ? withLeading.slice( 0, -1 ) : withLeading;
}

/**
 * Check if a session cookie is structurally valid: has a userId and token.
 *
 * Note: expiresAt in the cookie reflects the access token expiry, which the
 * backend auto-refreshes via the refresh token. Client-side expiry checks
 * against this value would prematurely invalidate sessions that the backend
 * would successfully refresh. Actual session expiry is enforced server-side
 * and caught by the 401 interceptor in the API layer.
 */
export function isSessionValid( sessionCookie?: SessionCookie ): boolean {
  if ( !sessionCookie?.userId || !sessionCookie?.token ) {
    return false;
  }

  return true;
}

/**
 * Clear the session cookie and redirect to login.
 * Called when the backend returns 401 (session expired or invalid).
 */
export function handleSessionExpired(): void {
  Cookies.remove( SESSION_COOKIE, {
    domain: window.location.hostname,
    path: '/'
  } );

  const basename = getBasename();
  const fullPath = window.location.pathname + window.location.search;
  const appPath = basename && ( fullPath === basename || fullPath.startsWith( `${ basename }/` ) )
    ? fullPath.slice( basename.length ) || '/'
    : fullPath;

  const fromOrigin = appPath === '/' || appPath === '';
  const redirectParam = !fromOrigin
    ? `?redirect=${ encodeURIComponent( appPath ) }`
    : '';

  window.location.replace( `${ basename }/login${ redirectParam }` );
}
